import React, { useState, useEffect, useContext } from "react";
import { AxiosInstance } from "../axios";

export const WishListContext = React.createContext();

const WishListItemsContextProvider = ({ children }) => {
  const [wishItems, setWishItems] = useState([]);
  const userJSON = sessionStorage.getItem("userDetails");
  let userId = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userId = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  useEffect(() => {
    if (userId) {
      WishNotify(userId); // Call cartNotify on component refresh
    } else {
      setWishItems([]);
    }
  }, []); // Dependency array ensures it runs when userId changes
  // Sync the fetched cartList with context state
  const WishNotify = async (usesrId) => {
    try {
      const updatedWish = await AxiosInstance.post("api/book/view_all_books", {
        search: "",
        category_id: "",
        group_course_id: "",
        subject_id: "",
        medium: "",
        is_set: "",
        view_all_book: 0,
        user_id: usesrId,
        book_id: "",
      });
      if (updatedWish?.data?.status) {
        setWishItems(updatedWish?.data?.data); // Update context state
      } else {
        setWishItems([]); // Update context state
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  return (
    <WishListContext.Provider value={{ wishItems, WishNotify }}>
      {children}
    </WishListContext.Provider>
  );
};

export default WishListItemsContextProvider;
